import DOMPurify from "isomorphic-dompurify";

/**
 * Sanitizes HTML content using DOMPurify with an allowlist of safe tags.
 * Strips all scripts, event handlers, and potentially dangerous markup
 * while preserving common formatting and layout elements.
 */
export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [
      // Text formatting
      "p", "br", "strong", "b", "em", "i", "u", "s", "small", "sub", "sup",
      "mark", "abbr", "code", "pre", "blockquote", "cite", "q",
      // Headings
      "h1", "h2", "h3", "h4", "h5", "h6",
      // Lists
      "ul", "ol", "li", "dl", "dt", "dd",
      // Links & media
      "a", "img",
      // Tables
      "table", "thead", "tbody", "tfoot", "tr", "th", "td", "caption", "colgroup", "col",
      // Sections
      "div", "span", "section", "article", "header", "footer", "hr",
    ],
    ALLOWED_ATTR: [
      "href", "target", "rel", "src", "alt", "title", "width", "height",
      "class", "id",
      // Audit 2026-04-25: removed `style` from the allowlist. Inline
      // CSS can carry javascript: URLs in url() functions, expression()
      // calls (legacy IE), and other vectors that DOMPurify's text-level
      // sanitisation doesn't catch. Modern browsers mostly defang these,
      // but defence in depth is cheap here — product descriptions +
      // campaign bodies use class-based styling, not inline style.
      // If a future use case genuinely needs inline CSS, swap to
      // DOMPurify's SAFE_FOR_TEMPLATES or use a CSS-allowlist parser.
      // Table attributes
      "colspan", "rowspan", "scope",
    ],
    // Force all links to open in new tab and prevent reverse tabnapping
    ADD_ATTR: ["target"],
    ALLOW_DATA_ATTR: false,
  });
}
